import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import LightBoxLayout from 'componets/light-box-layout';
import { EditTaxSettingForm } from 'modules/edit-tax-setting-form';
import { useEnterpriseLicensePlateTaxIdNumberUpdate } from '../use-license-pate-tax-id-number-update';
import analytics from 'service/analytics';

export const EditTaxSettingModal = ({
  isOpen,
  onClose,
  licensePlateId,
  taxSetting: currentTaxSetting,
  plateNumber,
  enterpriseTaxSettings,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const queryClient = useQueryClient();

  const {
    updateEnterpriseLicensePlateTaxIdNumberMutateAsync,
    updateEnterpriseLicensePlateTaxIdNumberMutateError,
  } = useEnterpriseLicensePlateTaxIdNumberUpdate();

  const handleSubmit = async taxSetting => {
    if (isLoading) return;

    analytics.licensePlatesEditTaxSettingButtonConfirmClick();

    try {
      setIsLoading(true);
      await updateEnterpriseLicensePlateTaxIdNumberMutateAsync({
        licensePlateId,
        taxIdNumber: taxSetting.taxIdNumber,
      });
      await queryClient.invalidateQueries('license-plates');
      onClose();
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LightBoxLayout show={isOpen} onClose={onClose}>
      {isOpen && (
        <EditTaxSettingForm
          isEdit
          title={`修改 ${plateNumber} 發票歸帳`}
          note="更新發票設定，所有尚未結帳的消費將依新設定處理。（例如：每月固定結帳日為 1 號，當在 7/15 更新設定，會適用到 7/1～7/31 的消費。）"
          isLoading={isLoading}
          enterpriseTaxSettings={enterpriseTaxSettings}
          defaultTaxSetting={currentTaxSetting}
          errorMessage={updateEnterpriseLicensePlateTaxIdNumberMutateError?.message}
          onSubmit={handleSubmit}
          onClose={onClose}
        />
      )}
    </LightBoxLayout>
  );
};
